module.exports = __webpack_public_path__ + "static/img/index10.1556cd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topImg/index10.jpg
// module id = 4koJ
// module chunks = 9